import { render, staticRenderFns } from "./HistorialCarta.vue?vue&type=template&id=211a4572&scoped=true"
import script from "./HistorialCarta.vue?vue&type=script&lang=js"
export * from "./HistorialCarta.vue?vue&type=script&lang=js"
import style0 from "./HistorialCarta.vue?vue&type=style&index=0&id=211a4572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a4572",
  null
  
)

export default component.exports